module.exports = __webpack_public_path__ + "img/6c06ebf.png";